// ZEN-372 — the words Settings shows before removing a category that
// expenses still use. Kept here so the screen and its tests read one copy.

export const beneficiaryFirstName = (student) =>
  (student?.nickname || (student?.full_name || student?.name || "").trim().split(/\s+/)[0] || "this beneficiary");

export const removeCategoryTitle = (name, student) =>
  `Remove ${name} from ${beneficiaryFirstName(student)}?`;

export const removeCategoryBody = (name, student, count) => {
  const who = beneficiaryFirstName(student);
  return count === 1
    ? `1 of ${who}'s expenses uses ${name}. Removing it will not change it: it keeps ${name}. You just won't be offered it when you add a new expense for ${who}.`
    : `${count} of ${who}'s expenses use ${name}. Removing it will not change them: they keep ${name}. You just won't be offered it when you add a new expense for ${who}.`;
};

export const REMOVE_CATEGORY_ACTION = "Remove category";

export const couldNotCheckCategoryUse = (name) =>
  `Could not check how many expenses use ${name}, so nothing was removed. Please try again.`;
